import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=bd80bfe4&scoped=true"
import script from "./step1.vue?vue&type=script&lang=ts"
export * from "./step1.vue?vue&type=script&lang=ts"
import style0 from "./step1.vue?vue&type=style&index=0&id=bd80bfe4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd80bfe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd80bfe4')) {
      api.createRecord('bd80bfe4', component.options)
    } else {
      api.reload('bd80bfe4', component.options)
    }
    module.hot.accept("./step1.vue?vue&type=template&id=bd80bfe4&scoped=true", function () {
      api.rerender('bd80bfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onBoarding/components/Steps/step1.vue"
export default component.exports